import dayjs from 'dayjs';
import { I18n } from '@aws-amplify/core';

import type { BeraReportV2ResultInformations } from '@/types/Bera';

const EMPTY_VALUE = '-';
const DATE_FORMAT = 'DD/MM/YYYY';

export function toTaskTime(informations: BeraReportV2ResultInformations): string {
	if (informations.taskTime === null) {
		return EMPTY_VALUE;
	}

	const result = `${informations.taskTime} ${I18n.get(informations.taskTimeFormat)}`;

	return result;
}

export function toCollectionDate(collectionDate: string | null): string {
	if (!collectionDate) {
		return EMPTY_VALUE;
	}

	const result = dayjs(collectionDate).format(DATE_FORMAT);

	return result;
}

export function toKnownInjury(hasKnownInjury: boolean | null): string {
	if (hasKnownInjury === null) {
		return EMPTY_VALUE;
	}

	if (hasKnownInjury) {
		const yes = I18n.get('Yes');

		return yes;
	}

	const no = I18n.get('No');

	return no;
}

export function toText(value: string): string {
	const result = value || EMPTY_VALUE;

	return result;
}
